export const modalDescriptions = {
  airport: {
    title: 'Що входить у наш аеропортний трансфер?',
    subtitle: '✈️ Аеропортний трансфер',
    image: '/img/modalDescription/airport.webp',
    imageAlt: 'Автомобіль для аеропортного трансферу',
    ariaLabel: {
      orderButton: 'Перейти до форми бронювання аеропортного трансферу',
      orderButtonText: 'Замовити трансфер',
      closeButton: 'Закрити модальне вікно',
    },
    list: [
      'Водій зустріне з табличкою біля виходу з терміналу.',
      'Допомога з багажем.',
      'Відстеження рейсу (ми знаємо, якщо рейс затримується).',
      'Очікування до 60 хв без доплати.',
      'Автомобілі преміум-класу (Wi-Fi, вода, дитяче крісло за запитом).',
      'Доступні напрямки: з/до аеропорту Вацлава Гавела.',
      'Ціни від 30 євро.',
    ],
    text: 'Наш трансфер до аеропорту — це гарантія спокійного початку або завершення вашої подорожі. Ми відстежуємо ваш рейс та забезпечуємо зустріч із табличкою в зоні прильоту. Водій допоможе з багажем і доставить вас у комфортному автомобілі з Wi-Fi прямо до дверей. Першу годину очікування ми не рахуємо, тож вам не доведеться турбуватися у разі затримки рейсу.',
  },

  corporate: {
    title: 'Ідеальне рішення для бізнесу',
    subtitle: '🧑‍💼 Корпоративний трансфер',
    image: '/img/modalDescription/corporate.webp',
    imageAlt: 'Автомобіль бізнес-класу для корпоративних клієнтів',
    ariaLabel: {
      orderButton: 'Перейти до форми бронювання корпоративного трансферу',
      orderButtonText: 'Замовити трансфер',
      closeButton: 'Закрити модальне вікно',
    },
    list: [
      'Обслуговування корпоративних клієнтів.',
      'Можливість підписання контракту з компанією.',
      'Щомісячна звітність та оплата по рахунку.',
      'Водії у костюмах, конфіденційність поїздок.',
      'Автомобілі від бізнес-класу і вище.',
      'Можливість замовлення на події, конференції, делегації.',
      'Відстеження маршруту через корпоративний кабінет.',
    ],
    text: 'Ми пропонуємо преміальне обслуговування для компаній, що цінують комфорт і пунктуальність. Трансфери між готелями, конференц-залами та аеропортом виконуються професійними водіями з досвідом обслуговування VIP-клієнтів. Можливе укладення договору та щомісячна оплата по рахунку. Ваші співробітники будуть вчасно й безпечно доставлені до місця призначення.',
  },

  personal: {
    title: 'Ваш водій на день, тиждень чи подорож',
    subtitle: '🚗 Персональний водій',
    image: '/img/modalDescription/personal.webp',
    imageAlt: 'Персональний водій з автомобілем преміум-класу',
    ariaLabel: {
      orderButton: 'Перейти до форми бронювання персонального водія',
      orderButtonText: 'Замовити водія',
      closeButton: 'Закрити модальне вікно',
    },
    list: [
      'Можна орендувати водія погодинно / на весь день.',
      'Поїздки по місту, зупинки, очікування — все включено.',
      'Автомобілі преміум-класу з водієм.',
      'Приватні поїздки, шопінг-тури, важливі зустрічі.',
      'Ідеально для гостей міста, VIP-клієнтів, старших людей.',
      'Водії розмовляють англійською/чеською.',
    ],
    text: 'Оренда персонального водія — це ідеальне рішення для тих, хто хоче мати мобільність і свободу пересування без зайвого клопоту. Наш водій супроводжуватиме вас протягом усього маршруту, незалежно від його складності. Ви можете замовити супровід на шопінг, ділові зустрічі чи навіть поїздку за місто. Преміум-авто, ввічливий сервіс і повна конфіденційність — усе включено.',
  },

  vip: {
    title: 'Розкіш і комфорт преміум-класу',
    subtitle: '👑 VIP та люкс-послуги',
    image: '/img/modalDescription/vip.webp',
    imageAlt: 'Автомобіль VIP-класу, готовий до поїздки',
    ariaLabel: {
      orderButton: 'Перейти до форми бронювання VIP-послуги',
      orderButtonText: 'Замовити VIP трансфер',
      closeButton: 'Закрити модальне вікно',
    },
    list: [
      'Персоналізований підхід для кожного клієнта.',
      'Автомобілі найвищого класу.',
      'Водії у костюмах, з досвідом обслуговування VIP-гостей.',
      'Повна конфіденційність.',
      'Додаткові опції: welcome-набір, мінеральна вода, газети.',
      'Ідеально для зустрічей з бізнес-партнерами, дипломатичних поїздок, весіль та світських подій.',
      'Підтримка 24/7 і особистий менеджер.',
    ],
    text: 'Оренда персонального водія — це ідеальне рішення для тих, хто хоче мати мобільність і свободу пересування без зайвого клопоту. Наш водій супроводжуватиме вас протягом усього маршруту, незалежно від його складності. Ви можете замовити супровід на шопінг, ділові зустрічі чи навіть поїздку за місто. Преміум-авто, ввічливий сервіс і повна конфіденційність — усе включено.',
  },

  tours: {
    title: 'Подорожуйте з комфортом і задоволенням',
    subtitle: '🌍 Тури та екскурсії',
    image: '/img/modalDescription/vip.webp',
    imageAlt: 'Автомобіль для турів та екскурсій у Європі',
    ariaLabel: {
      orderButton: 'Перейти до форми бронювання туру або екскурсії',
      orderButtonText: 'Замовити тур',
      closeButton: 'Закрити модальне вікно',
    },
    list: [
      'Організація індивідуальних та групових турів.',
      'Можливість обрати гіда або тільки водія.',
      'Гнучкі маршрути по Чехії та Європі (Карлові Вари, Відень, Дрезден, Мюнхен, тощо).',
      'Комфортабельні автомобілі, кондиціонер, Wi-Fi, питна вода.',
      'Фото-паузи, час на шопінг, харчування в місцевих ресторанах.',
      'Туристична страховка та підтримка в дорозі.',
      'Можливість бронювання через онлайн-форму.',
    ],
    text: 'Відкрийте для себе Європу разом з нами — без стресу та зайвих турбот. Ми організуємо індивідуальні або групові тури відповідно до ваших інтересів і побажань. Наші гіди можуть супроводжувати вас, або ви просто насолодитесь комфортною поїздкою з професійним водієм. Всі маршрути створюються з акцентом на зручність, безпеку та враження, які залишаться надовго.',
  },
};
